 import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography } from '@mui/material'

import TablePagination from '@mui/material/TablePagination'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import excel_img from '../../../asset/excel_img.png'
import Api from '../../../Api/Api'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'

import { useNavigate } from 'react-router-dom'
import ExportToExcel from '../../../Components/ExportToExcel'

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },

  TableCellHeader1: { background: '#2F2E41', color: '#ffffff', borderBottom: '1px solid #CCCCCC' },
}

export default function AccountManage() {
  const navigate = useNavigate()
  const onClickToRegister = () => {
    navigate('/User/Auth/Register')
  }

  const [pg, setpg] = React.useState(0)
  const [rpg, setrpg] = React.useState(5)
  const [userList, setUserList] = useState([])

  const columns = useMemo(
    () => [
      {
        id: 'id',
        accessorKey: 'uid',
        header: '아이디',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'ph',
        header: '전화번호',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'ml',
        header: '이메일',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'orgid',
        header: '부서ID',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'puid',
        header: '상위관리자ID',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        // uid
        id: 'delete',
        accessorKey: 'uid',
        mantineTableBodyCellProps: ({ cell }) => ({
          onClick: () => {
            UsersDelete(cell.getValue())
          },
        }),
        //or in the component override callbacks like this
        Cell: ({ cell }) => {
          return (
            <Button sx={{ color: '#CCCCCC' }}>
              <DeleteOutlineIcon />
            </Button>
          )
        },
        header: '삭제',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: columns,
    data: userList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row) => row.ji,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    // enableRowSelection: true,
    // enableMultiRowSelection: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: false,
    enableFullScreenToggle: false,
    paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },
    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'center',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'center',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  function handleChangePage(event, newpage) {
    setpg(newpage)
  }
  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10))
    setpg(0)
  }

  useEffect(() => {
    Users()
  }, [])

  const Users = async () => {
    try {
      const response = await Api.get('/api/v1/users')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setUserList(response.data)
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      console.log('Users exception', e)
    }
  }

  const UsersDelete = async (param) => {
    const uid = param
    const resultConfirm = window.confirm(`${uid}를 삭제 하시겠습니까?`)
    if (resultConfirm) {
      try {
        const response = await Api.delete(`/api/v1/users/${uid}`)
        // const response = await Api.get('/api/v1/orgn', {
        //   withCredentials: true,
        // })
        if (response.status === 200 || response.status === 204) {
          Users()
          alert('삭제 되었습니다.')
        } else {
          alert('삭제 되지 않았습니다.')
        }
        // console.log('response.data Users', response.data)
      } catch (e) {
        console.log('UsersDelete exception', e)
      }
    }
  }

  return (
    <Grid container spacing={1} sx={{ marginLeft: 3, marginRight: 3 }}>
      <Grid size={12}>
        <Typography sx={styles1.Typography1}>계정관리</Typography>
      </Grid>
      <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 1 }}>
      <ExportToExcel data={userList} fileName={`계정관리목록`}/>
        <Button
          variant="contained"
          sx={{ marginLeft: 2, color: '#ffffff', background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)' }}
          onClick={() => onClickToRegister()}
        >
          계정 등록
        </Button>
      </Grid>
      <Grid size={12}>
        <Paper>
          <MantineReactTable table={table} />
        </Paper>
      </Grid>
    </Grid>
  )
}
